import axios from "axios";
import { REACT_APP_MAPS_API_KEY } from "../../../config";
import { FieldInputProps } from "formik";
import { AddressMapData, GeoCodingData, searchParams } from "./models";
import { autoFillAddress } from "./helper";

export async function getCoordinatesFromAddress(queryObj: searchParams) {
  try {
    const searchKey: string = Object.keys(queryObj)[0];
    const { data } = await axios.get(
      "https://maps.googleapis.com/maps/api/geocode/json",
      {
        params: {
          [searchKey]: queryObj[`${searchKey}` as keyof searchParams],
          key: REACT_APP_MAPS_API_KEY,
        },
      }
    );

    if (data.status === "OK") {
      return data.results;
    } else if (data.status === "ZERO_RESULTS") {
      return data.status;
    } else {
      throw new Error(data.status);
    }
  } catch (error) {
    console.error("Failed to get coordinates:", error);
    return null;
  }
}

export async function handleAddressSearch(
  field: FieldInputProps<AddressMapData>,
  queryObj: searchParams,
  currentAddress?: AddressMapData
): Promise<GeoCodingData | string | null> {
  const geocoding = await getCoordinatesFromAddress(queryObj);

  if (
    Array.isArray(geocoding) &&
    geocoding.length >= 1 &&
    geocoding[0].hasOwnProperty("geometry") &&
    geocoding[0].geometry.hasOwnProperty("location")
  ) {
    const newMapData = autoFillAddress(
      geocoding[0],
      field,
      currentAddress
    );
    return { mapData: { ...newMapData } };
  } else if ((geocoding as unknown) === "ZERO_RESULTS") {
    return "No results";
  } else {
    return null;
  }
}
